import request from '@/utils/request'

/**
 * FBA仓下拉选项（仅启用仓），供 OMS 建FBA仓选用（含物流产品绑定FBA）。
 */
export function getFbaWarehouseOptions(params) {
    return request({
        url: '/wms/fbaWarehouse/options',
        method: 'get',
        params
    })
}